import React from 'react'

import { Record } from '../../../models'
import { Link } from 'react-router-dom'

interface RecordTableProps {
    record: Record
}

export const RecordTable = (props: RecordTableProps) => {
    const { record } = props

    return (
        <table className="table">
            <tbody>
                <tr>
                    <th>Record ID</th>
                    <td>{record.id}</td>
                </tr>
                <tr>
                    <th>Status</th>
                    <td>{record.status.name}</td>
                </tr>
                <tr>
                    <th>Agency</th>
                    <td>
                        <Link to={`/agencies/${record.agency.id}`} className="text-nowrap">
                            {record.agency.name}
                        </Link>
                    </td>
                </tr>
                <tr>
                    <th>First Name</th>
                    <td>{record.guestFirstName}</td>
                </tr>
                <tr>
                    <th>Last Name</th>
                    <td>{record.guestLastName}</td>
                </tr>
                <tr>
                    <th>Confirmation Number</th>
                    <td>{record.confirmationNumber}</td>
                </tr>
                <tr>
                    <th>Refund Support Link</th>
                    <td>
                        {record.refundSupportLink ? (
                            <a
                                href={record.refundSupportLink}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-primary text-decoration-underline"
                            >
                                View Link
                            </a>
                        ) : (
                            <span className="text-muted">No link provided</span>
                        )}
                    </td>
                </tr>
            </tbody>
        </table>
    )
}
